// extracted by mini-css-extract-plugin
export var chevronIcon = "_62-2";
export var teamName = "_62-1";
export var teamSwitcherButton = "_62-0";